import React from 'react';
import { SectionWrapper } from '../ui/SectionWrapper';
import { Check } from 'lucide-react';
export function WhoThisIsForSection() {
  return <SectionWrapper background="muted" data-id="element-270">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-271">
        <div data-id="element-272">
          <h2 className="text-2xl font-bold text-slate-900 mb-6" data-id="element-273">
            Built for Professionals
          </h2>
          <p className="text-slate-600 mb-8 text-sm leading-relaxed" data-id="element-274">
            D2D Guides is designed for those who treat this industry as a
            serious career or business enterprise, not a get-rich-quick scheme.
          </p>

          <div className="space-y-3" data-id="element-275">
            <h3 className="text-xs font-bold text-slate-400 uppercase tracking-wider mb-3" data-id="element-276">
              Primary Audience
            </h3>
            {['Operators scaling teams beyond 10 reps', 'National companies opening D2D channels', 'Career reps evaluating leadership paths', 'Investors conducting due diligence'].map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-277">
                <Check className="w-4 h-4 text-teal-600" data-id="element-278" />
                <span className="text-sm text-slate-700 font-medium" data-id="element-279">
                  {item}
                </span>
              </div>)}
          </div>
        </div>

        <div className="bg-white p-8 rounded-lg border border-slate-200 shadow-sm flex flex-col justify-center" data-id="element-280">
          <h3 className="font-bold text-slate-900 mb-4" data-id="element-281">Not for everyone.</h3>
          <p className="text-sm text-slate-600 mb-6" data-id="element-282">
            We write deep, technical breakdowns of complex systems. If you're
            looking for "hacks", "secrets", or guaranteed income, this platform
            isn't for you.
          </p>
          <div className="text-xs text-slate-400 italic" data-id="element-283">
            * We prioritize long-term sustainability over short-term hype.
          </div>
        </div>
      </div>
    </SectionWrapper>;
}